function removeMask(value) {
  return value.replace(/[^0-9]+/g, '')
}

export default removeMask
